import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestCaruse } from "../../entity/EntityRequestCaruse";
import { EntityRequest } from "../../entity/EntityRequest";

export class DtoRequestCarusesGetRes extends EntityRequestCaruse {
  public request = new EntityRequest();
  
  public items: EntityRequestCaruse[]  = [];
}
